import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useMenuApp } from '@/components/feature/MenuApp';

interface CabecalhoAdminProps {
  titulo: string;
  subtitulo?: ReactNode;
  eyebrow?: string;
  voltarPara?: string;
  voltarRotulo?: string;
  acao?: ReactNode;
  aoLadoDoTitulo?: ReactNode;
}

/**
 * Cabeçalho padrão das telas administrativas (meus eventos, gerenciar, direção).
 * Mantém título, subtítulo, link de voltar e ação à direita sempre no mesmo
 * desenho, para que toda a área do organizador tenha a mesma cara.
 */
export default function CabecalhoAdmin({
  titulo,
  subtitulo,
  eyebrow,
  voltarPara,
  voltarRotulo,
  acao,
  aoLadoDoTitulo,
}: CabecalhoAdminProps) {
  const { abrir: abrirMenu } = useMenuApp();
  return (
    <header>
      {voltarPara && (
        <Link
          to={voltarPara}
          className="inline-flex cursor-pointer items-center gap-2 text-sm font-medium text-secondary-600 transition-colors hover:text-foreground-900"
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-left-line" />
          </span>
          {voltarRotulo ?? 'Voltar'}
        </Link>
      )}

      <div
        className={`flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between ${
          voltarPara ? 'mt-4' : ''
        }`}
      >
        <div>
          {eyebrow && (
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-primary-600">
              {eyebrow}
            </p>
          )}
          <div className={`flex items-center gap-2 ${eyebrow ? 'mt-1' : ''}`}>
            <h1 className="text-[28px] font-normal text-foreground-950">{titulo}</h1>
            {aoLadoDoTitulo}
          </div>
          {subtitulo && <p className="mt-1 text-sm text-secondary-500">{subtitulo}</p>}
        </div>
        <div className="flex shrink-0 items-center justify-end gap-2">
          {acao}
          <button
            type="button"
            onClick={abrirMenu}
            aria-label="Menu"
            className="aperta flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full text-foreground-700 hover:bg-background-100 md:hidden"
          >
            <i className="ri-menu-line text-[22px]" aria-hidden />
          </button>
        </div>
      </div>
    </header>
  );
}